export var isArrNullOrEmpty = function isArrNullOrEmpty(arrToCheck) {
  return !(arrToCheck === null || arrToCheck === void 0 ? void 0 : arrToCheck.length);
};